/* eslint-disable @next/next/no-img-element */
"use client";

import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const RealConnection = () => {
  const [text, setText] = useState("");
  const fullText = "One place. One team. Total clarity.";

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      setText(fullText.slice(0, index));
      index++;
      if (index > fullText.length) clearInterval(interval);
    }, 50); // typing speed (ms per letter)
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="w-full bg-[#4177BC] text-white py-24 px-6 overflow-hidden">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center justify-between gap-12">
        {/* LEFT IMAGE */}
        <motion.div
          className="flex-1 flex justify-center"
          initial={{ opacity: 0, x: -50, scale: 0.95 }}
          whileInView={{ opacity: 1, x: 0, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <img
            src="/Frame 2147225759.png"
            alt="Real Connection"
            className="w-full max-w-[700px] h-auto rounded-xl shadow-lg"
          />
        </motion.div>

        {/* RIGHT CONTENT */}
        <div className="flex-1 text-center lg:text-left max-w-[550px]">
          {/* TYPEWRITER HEADING (no transform at all) */}
          <h1
            className="text-4xl md:text-5xl judson-bold leading-tight border-r-4 border-white pr-2 animate-cursor"
            style={{
              overflow: "hidden",
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {text}
          </h1>

          {/* PARAGRAPH (fade-in only) */}
          <motion.p
            className="text-base md:text-lg text-white/90 leading-relaxed mb-6 mt-4 inter-regular"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            viewport={{ once: true }}
          >
            AskLocal gives you a single, secure space to manage your real estate
            journey. You build your team of trusted local professionals, get
            answers when you need them, and move through each step with
            transparency and control without pressure or guesswork. No noise. No
            chasing people down. Just clarity at every step.
          </motion.p>

          {/* BUTTON (scale-in only) */}

          <motion.button
            onClick={() => {
              // 1️⃣ scroll to top
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });

              // 2️⃣ wait for scroll animation, then open modal
              setTimeout(() => {
                window.dispatchEvent(new Event("openAskLocalConcierge"));
              }, 600); // timing tuned for smooth UX
            }}
            className="inline-block bg-[#EB9C2C] text-white inter-semibold px-8 py-3 rounded-xl hover:bg-white hover:text-black cursor-pointer transition-all duration-300 shadow-md"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            Learn More
          </motion.button>
        </div>
      </div>
    </section>
  );
};

export default RealConnection;
